import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import PrivacyNotice from './pages/PrivacyNotice';
import ProtectedRoute from './components/ProtectedRoute';

export default function App() {
  return (
    <div style={{ margin: 0, padding: 0, background: '#0a0a1a', minHeight: '100vh' }}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute><AdminDashboard /></ProtectedRoute>
          } />
          <Route path="/privacy" element={<PrivacyNotice />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}